export default {
  text: {
    fontSize: 14,
    paddingBottom: 8,
    wordBreak: 'break-all',
    whiteSpace: 'pre-line',
  },
}
